import React from 'react';

import { Dialog, Button, Typography, Stack } from '@gogame/components';

const ExistedMetric = ({ onClose, open, name, onSearch }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <Dialog.Content>
        <Stack spacing={2}>
          <Typography variant={'h6'}>
            Metric with the same attributes already exists
          </Typography>
          <Typography>Metric name: {name}</Typography>
        </Stack>
      </Dialog.Content>

      <Dialog.Actions>
        <Button type={'button'} onClick={onClose}>
          Close
        </Button>
        <Button
          type={'button'}
          onClick={() => {
            onSearch();
            onClose();
          }}
        >
          view metric
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

export default ExistedMetric;
